import { Role } from "@/api/types";
import React from "react";

interface RoleChipsProps {
  roles?: Role[] | null;
  className?: string;
  quiet?: boolean;
}

const RoleChips: React.FC<RoleChipsProps> = ({
  roles,
  className,
  quiet = true,
}) => {
  const roleColors = {
    admin: "bg-red-100 text-red-800",
    facilitator: "bg-orange-100 text-orange-800",
    participant: "bg-green-100 text-green-800",
    none: "bg-gray-100 text-gray-800",
  };

  return (
    <div className={`flex flex-wrap gap-2 ${className}`}>
      {roles
        ? roles.map((role) => (
            <span
              key={role}
              className={`px-2 py-1 rounded text-xs ${
                roleColors[role] || "bg-gray-100 text-gray-800"
              }`}
            >
              {role}
            </span>
          ))
        : !quiet && (
            <span className={`px-3 py-1 rounded text-xs ${roleColors["none"]}`}>
              No roles assigned
            </span>
          )}
    </div>
  );
};

export default RoleChips;
